import { render, staticRenderFns } from "./RejectAudit.vue?vue&type=template&id=bf7e4b06&"
import script from "./RejectAudit.vue?vue&type=script&lang=js&"
export * from "./RejectAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports